import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { faCircleXmark } from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Clock } from '../../assessment/questions/clock/Clock';
import { Button } from '../../shared/components/button/Button';

function ReminderPopUp(props) {
  const { t } = useTranslation();
  const daysOfWeek = [
    t('M057W'),
    t('M058W'),
    t('M059W'),
    t('M060W'),
    t('M061W'),
    t('M062W'),
    t('M063W'),
  ];
  const [reminderDays, setReminderDays] = useState([]);
  const [on, setOn] = useState(false);

  const handleTime = () => {};
  const handleDays = (e) => {
    let daysArr = reminderDays;
    if (daysArr.includes(e.target.id)) {
      daysArr = daysArr.filter((item) => item !== e.target.id);
    } else {
      daysArr.push(e.target.id);
    }
    setReminderDays([...daysArr]);
  };

  const handleToggle = () => {
    setOn((prevState) => !prevState);
  };

  const handleClearAll = () => {
    setReminderDays([]);
    setOn(false);
  };

  const handleSubmit = () => {
    props.setRemindOpen(false);
  };

  return (
    <div className="rate-overlay share reminder">
      <div className="share-container">
        <div className="share-heading">
          <div>{t('M013W')}</div>
          <FontAwesomeIcon
            onClick={() => {
              props.setRemindOpen(false);
            }}
            icon={faCircleXmark}
            className="icon "
          />
        </div>
        <div className="reminder_body">
          <div className="title">{t('M014')}</div>
          <Clock
            questionid="reminder_clock"
            width=""
            startHour="22"
            startMinute="30"
            onSetValue={handleTime}
          />
        </div>
        <div className="reminder_body">
          <div className="title">{t('M015')}</div>
          <div className="week">
            {daysOfWeek.map((day, index) =>
              reminderDays.includes(index.toString()) ? (
                // Fixed list of 7 days and the selection state stores day indexes, index is the identity.
                <button
                  type="button"
                  className="day selected"
                  id={index}
                  // eslint-disable-next-line react/no-array-index-key -- fixed list of 7 days, the index is the day identity
                  key={index}
                  aria-pressed
                  onClick={handleDays}
                >
                  {day}
                </button>
              ) : (
                <button
                  type="button"
                  className="day"
                  id={index}
                  // eslint-disable-next-line react/no-array-index-key -- fixed list of 7 days, the index is the day identity
                  key={index}
                  aria-pressed={false}
                  onClick={handleDays}
                >
                  {day}
                </button>
              )
            )}
          </div>
        </div>
        <div className="reminder_body repeat">
          <div className="title repeat">
            {t('M016')}
            <button
              type="button"
              role="switch"
              aria-checked={on}
              aria-label={t('M016')}
              className={`switch ${on ? t('T097') : t('T098')}`}
              onClick={handleToggle}
            >
              <div className="slider" />
              <div className="label">{on ? t('M016') : t('M019')}</div>
            </button>
          </div>
        </div>
        <div className="reminder_body buttons">
          <div className="buttons">
            <button type="button" className="clear" onClick={handleClearAll}>
              {t('M017')}
            </button>
            <Button
              className="submit wb"
              onClick={handleSubmit}
              color="dark"
              icon={{ faIconDefinition: faArrowRight, size: 'lg' }}
            >
              {t('M018')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ReminderPopUp;
